"use client";

import { Core } from "@faire/slate/foundation/color";
import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import { iconCls } from "@faire/slate/lib/tracking";
import React from "react";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1576))
 * @trackcomponent
 * @lastsynced 2025-07-07T19:23:54.929Z
 * @optimized using svgo:^3.0.2
 */
export const EyeClosed = createSVGIcon(
  <>
    <path
      d="M20.441 8.728a24 24 0 0 1 2.246 2.131 1.656 1.656 0 0 1 0 2.284C20.88 15.087 16.776 18.858 12 18.858a9.7 9.7 0 0 1-1.687-.153M4.08 15.693a23.6 23.6 0 0 1-2.767-2.55 1.656 1.656 0 0 1 0-2.284C3.12 8.915 7.223 5.144 12 5.144c.839.003 1.674.113 2.486.329M15.327 12.832a3.43 3.43 0 0 1-2.496 2.496"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.571 12A3.43 3.43 0 0 1 12 8.573M21.428 2.572 2.571 21.43"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "EyeClosed",
  {
    className: iconCls(),
    color: Core.icon.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
